import { defaultLocale } from '../../helpers/locale';

export const languageFromLocale = (locale?: string): string => {
  const currentLocale = !locale ? defaultLocale : locale;
  const [languageCode] = currentLocale.split('-');
  return languageCode as string;
};
